module.exports = __webpack_public_path__ + "static/x86.51d57655.png";